@if (clipboard.length > 0) {
  <button mat-icon-button (click)="clipDrawer.toggle()">
    <mat-icon [svgIcon]="'mat_solid:content_paste'" [matBadge]="getBadgeText()" [matBadgeHidden]="clipboard.length === 0"></mat-icon>
  </button>
}

<fuse-drawer
  class="w-screen min-w-screen sm:w-140 sm:min-w-140 z-999"
  fixed
  [mode]="'over'"
  [name]="'clipDrawer'"
  [position]="'right'"
  #clipDrawer>

  <div class="flex flex-col w-full overflow-auto bg-card">
    <div class="flex flex-row items-center px-6 h-20 min-h-20 text-on-primary bg-primary">
      <mat-icon class="icon-size-7 text-current" [svgIcon]="'mat_solid:content_paste'"></mat-icon>
      <div class="ml-3 text-2xl font-semibold tracking-tight">{{ 'clipboard.clipboard' | transloco }}</div>
      <button class="ml-2" mat-icon-button matTooltip="{{ 'clipboard.discardAll' | transloco }}" (click)="clearClipboard()">
        <mat-icon class="text-current" [svgIcon]="'mat_outline:delete'"></mat-icon>
      </button>
      <button class="ml-auto" mat-icon-button (click)="clipDrawer.close()">
        <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
      </button>
    </div>
    <div class="flex flex-col p-6">
      @if (clipboard.length > 0) {
        @for (item of clipboard; track item; let i = $index) {
          <div class="py-2 flex items-center justify-between">
            <div class="flex">
              <span class="font-semibold mr-1">{{ ('clipboard.' + item.type) | transloco }}</span>
              @if (fieldTypes.includes(item.type)) {
                <span> - {{ item.name }}</span>
              }
            </div>
            <div class="flex">
              @if (canPaste(item)) {
                <button mat-icon-button matTooltip="{{ 'clipboard.paste' | transloco }}" (click)="paste(item)">
                  <mat-icon [svgIcon]="'mat_outline:content_paste'"></mat-icon>
                </button>
              }
              <button mat-icon-button matTooltip="{{ 'clipboard.showData' | transloco }}" (click)="showData(item)">
                <mat-icon [svgIcon]="'mat_outline:info'"></mat-icon>
              </button>
              <button mat-icon-button matTooltip="{{ 'clipboard.discardItem' | transloco }}" (click)="discardItem(i)">
                <mat-icon [svgIcon]="'mat_outline:delete'"></mat-icon>
              </button>
            </div>
          </div>
          <hr class="my-2">
        }
      } @else {
        <h3 class="text-center p-4">{{ 'clipboard.noItems' | transloco }}</h3>
      }
    </div>
  </div>
</fuse-drawer>

